import { render, staticRenderFns } from "./BlackAccounts.vue?vue&type=template&id=56dea2c4&scoped=true&"
import script from "./BlackAccounts.vue?vue&type=script&lang=js&"
export * from "./BlackAccounts.vue?vue&type=script&lang=js&"
import style0 from "./BlackAccounts.vue?vue&type=style&index=0&id=56dea2c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dea2c4",
  null
  
)

export default component.exports